const Blob = () => <span style={{ margin: '0 6px', color: '#bfbfbf' }}>•</span>;

export default Blob;
